<script setup>
import { computed, watch, ref, onMounted } from 'vue';
import AppTopbar from './AppTopbar.vue';
// import AppFooter from './AppFooter.vue';
import AppSidebar from './AppSidebar.vue';
import { useLayout } from '@/layout/composables/layout';
import UserStore from '@/service/auth/UserService';
import { useConferenceStore } from '@/service/conference/ConferenceService';
import DataFormatterService from '@/service/app/DataFormatterService';

const UserService = UserStore();

const formatter = new DataFormatterService();

const { layoutConfig, layoutState, isSidebarActive } = useLayout();

const outsideClickListener = ref(null);

watch(isSidebarActive, (newVal) => {
    if (newVal) {
        bindOutsideClickListener();
    } else {
        unbindOutsideClickListener();
    }
});

const containerClass = computed(() => {
    return {
        'layout-theme-light': !layoutConfig.darkTheme.value,
        'layout-theme-dark': layoutConfig.darkTheme.value,
        'layout-overlay': layoutConfig.menuMode.value === 'overlay',
        'layout-static': layoutConfig.menuMode.value === 'static',
        'layout-static-inactive': layoutState.staticMenuDesktopInactive.value && layoutConfig.menuMode.value === 'static',
        'layout-overlay-active': layoutState.overlayMenuActive.value,
        'layout-mobile-active': layoutState.staticMenuMobileActive.value,
        'p-input-filled': layoutConfig.inputStyle.value === 'filled',
        'p-ripple-disabled': !layoutConfig.ripple.value,
        'has-event-box': conferenceStore.showEventBox,
    };
});
const bindOutsideClickListener = () => {
    if (!outsideClickListener.value) {
        outsideClickListener.value = (event) => {
            if (isOutsideClicked(event)) {
                layoutState.overlayMenuActive.value = false;
                layoutState.staticMenuMobileActive.value = false;
                layoutState.menuHoverActive.value = false;
            }
        };
        document.addEventListener('click', outsideClickListener.value);
    }
};
const unbindOutsideClickListener = () => {
    if (outsideClickListener.value) {
        document.removeEventListener('click', outsideClickListener);
        outsideClickListener.value = null;
    }
};
const isOutsideClicked = (event) => {
    const sidebarEl = document.querySelector('.layout-sidebar');
    const topbarEl = document.querySelector('.layout-menu-button');

    return !(sidebarEl.isSameNode(event.target) || sidebarEl.contains(event.target) || topbarEl.isSameNode(event.target) || topbarEl.contains(event.target));
};


const conferenceStore = useConferenceStore();
const getLatestConference = () => {
    conferenceStore.fetchLatestConference(UserService);
};

const removeEventBox = () => {
    conferenceStore.removeEventBox(UserService);
}

onMounted(() => {
    getLatestConference();
});
</script>

<template>
    <div class="layout-wrapper" :class="containerClass">
        <div class="event-box" v-if="conferenceStore.showEventBox">
            <span class="event-short-info">
                {{ conferenceStore.latestConference.title }}
                | {{ formatter.formatDateTime(conferenceStore.latestConference.event_start_date, 'MMM D, YYYY') }}

                <router-link :to="{ name: 'conference', params: { tag: conferenceStore.latestConference.tag }}" @click="removeEventBox">
                    <Button label="Read More" severity="secondary"  icon="pi pi-angle-double-right" iconPos="right" />
                </router-link>
            </span>
            <span class="remove-event-box" @click="removeEventBox"><i class="pi pi-times-circle" style="font-size: 1.5rem"></i></span>
        </div>
        <app-topbar></app-topbar>
        <div class="layout-sidebar">
            <div class="manager-info" v-if="UserService.getUserInfo?.manager">
                <div class="user-avater">
                    <img v-if="UserService.getUserInfo.manager.avater == 'profile.png' || UserService.getUserInfo.manager.avater == ''" src="/images/profile.png" />
                    <img v-else :src="UserService.getUserInfo.manager.avater" />
                </div>
                <h4>{{ UserService.getUserInfo.manager.name }}</h4>
                <h6>{{ UserService.getUserInfo.manager.title }}</h6>
                <br/>
                <br/>
                <p>{{ UserService.getUserInfo.manager.phone }}</p>
                <p>{{ UserService.getUserInfo.manager.email }}</p>
            </div>
            <app-sidebar></app-sidebar>
        </div>
        <div class="layout-main-container">
            <div class="layout-main">
                <!-- <router-view v-slot="{ Component }">
                    <transition name="route" mode="out-in">
                        <component :is="Component"></component>
                    </transition>
                </router-view> -->
                <router-view />
            </div>
            <!-- <app-footer></app-footer> -->
        </div>
        <div class="layout-mask"></div>
    </div>
</template>

<style>
.event-box {
    z-index: 999;
    position: fixed;
    width: 100%;
    text-align: center;
    padding: 7px;
    background-color: #10b981;
    color: var(--highlight-text-color);
    height: 40px;
}
span.remove-event-box {
    position: fixed;
    right: 15px;
    top: 8px;
    color: #fff;
    cursor: pointer;
}
.layout-wrapper.has-event-box .layout-topbar {
    top: 40px;
}
.layout-wrapper.has-event-box .layout-main-container {
    padding-top: calc( 8rem + 40px );
}
.layout-wrapper.has-event-box .layout-sidebar {
    top: calc( 7rem + 40px );
}
span.event-short-info {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
}
span.event-short-info button.p-button {
    font-size: 10px;
    padding: 5px 10px;
    margin-left: 10px;
}
.manager-info {
    text-align: center;
    padding: 2rem 2rem;
    background-color: var(--surface-hover);
    color: var(--text-color);
    font-size: 10px;
    box-shadow: 0px -1px 5px 0px var(--shadow);
    border-radius: 15px;

}
.manager-info .user-avater img {
    width: 60px;
}
.manager-info h4 {
    margin-bottom: 0px;
    margin-top: 10px;
    text-transform: capitalize;
    font-size: 14px;
    font-weight: 700;
}
.manager-info h6 {
    margin-bottom: 0px;
    margin-top: 3px;
    text-transform: capitalize;
    font-size: 12px;
}
.manager-info p {
    margin-bottom: 0px;
    font-size: 13px;
}
</style>
